/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/**
 * 可注入的实体类
 * @public
 */
const Type = Function;

export { Type };
//# sourceMappingURL=type.js.map
